import { type FC } from "react";
import { useTranslation } from "react-i18next";

import {
  DATE_FORMAT_DMY,
  formatDatetime,
  formatFromNowTime,
  useFormats,
  useTimezone,
} from "@ryde/shared";

import { FramerTooltip } from "../../common";
import { type IRenderColumnTemplate } from "./_core";
import { DateEditableTemplateWrapper } from "./date-editable.styled";

export const DateCountdownCellTemplate: FC<IRenderColumnTemplate> = ({
  value,
  name,
}) => {
  const { timezone } = useTimezone();
  const { timeFormat } = useFormats();
  const { t } = useTranslation();

  const formattedValue = formatDatetime({
    dateTimeISO: value as TDateISO,
    dateFormat: DATE_FORMAT_DMY,
    timeFormat,
    timezone,
  });

  const translationDate =
    name === "createdAt"
      ? t("general.CREATED_ON", { date: formattedValue })
      : "";

  return (
    <DateEditableTemplateWrapper>
      <FramerTooltip content={translationDate} rtlStrippedBottomLeftPlacement>
        {formatFromNowTime(value, timezone)}
      </FramerTooltip>
    </DateEditableTemplateWrapper>
  );
};
